import { apiAxios } from "../apiConfig";

export const getAllEvents = async () => {
  try {
    const response = await apiAxios.get("/events");
    return response.data;
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};

export const rsvpToEvent = async (eventId, data) => {
  try {
    const response = await apiAxios.post(`/events/${eventId}/rsvp`, data);
    return response.data;
  } catch (error) {
    console.error("Error RSVPing to event:", error);
    throw error;
  }
};
